import * as React from 'react';
import { useRef, useEffect } from 'react';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkPriceLockup, UitkPriceLockupAlign } from 'uitk-react-price-lockup';
import { UitkScrim, UitkScrimType, UitkScrimColorType } from 'uitk-react-scrim';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-progress-indicator.css';
import { UitkProgressStep } from './components/uitk-progress-step.esm.js';
import { applyFade, getOffsetNeededToCenterStep } from './utils.esm.js';

var getClassNameList = classNames.bind(styles);
// PriceLockup will be deprecated and replaced with another new component, the new component should be part of the secondaryContent[]
var UitkProgressIndicator = function (_a) {
    var changeFlightOnClickCallback = _a.changeFlightOnClickCallback, priceLockup = _a.priceLockup, steps = _a.steps, secondaryContent = _a.secondaryContent;
    var baseClassName = 'uitk-progress-indicator';
    var listClassNames = getClassNameList(baseClassName, 'unfade-end');
    var stepIndicatorRef = useRef(null);
    var currentStepRef = useRef(null);
    var buttonScroll = function (event) {
        if (event.currentTarget) {
            applyFade(event.currentTarget);
        }
    };
    useEffect(function () {
        applyFade(stepIndicatorRef.current);
        var resizeTimeout;
        var onWindowResize = function () {
            if (!resizeTimeout) {
                resizeTimeout = setTimeout(function () {
                    resizeTimeout = null;
                    applyFade(stepIndicatorRef.current);
                }, 200);
            }
        };
        window.addEventListener('resize', onWindowResize);
        if ((stepIndicatorRef === null || stepIndicatorRef === void 0 ? void 0 : stepIndicatorRef.current) && (currentStepRef === null || currentStepRef === void 0 ? void 0 : currentStepRef.current)) {
            // Scroll such that the current step is centered in the progress indicator.
            stepIndicatorRef.current.scrollLeft = getOffsetNeededToCenterStep(stepIndicatorRef.current, currentStepRef.current);
        }
        return function () {
            window.removeEventListener('resize', onWindowResize);
        };
    }, []);
    return (React.createElement(UitkLayoutGrid, { columns: 8, space: "four", alignContent: "center", dataTestId: baseClassName },
        React.createElement(UitkLayoutGridItem, { colSpan: priceLockup ? { small: 8, medium: 6, extra_large: 6 } : 8 },
            React.createElement("div", { className: "".concat(baseClassName, "-container") },
                React.createElement("ul", { ref: stepIndicatorRef, className: listClassNames, onScroll: buttonScroll }, steps.map(function (step, index) { return (React.createElement(UitkProgressStep, { key: "".concat(baseClassName, "-step-").concat(index), baseClassName: baseClassName, changeFlightOnClickCallback: changeFlightOnClickCallback, displayChevron: index < steps.length - 1, index: index, step: step, currentStepRef: currentStepRef })); })),
                React.createElement("div", { className: "".concat(baseClassName, "-fade-start") },
                    React.createElement(UitkScrim, { type: UitkScrimType.LEADING, color: UitkScrimColorType.SECONDARY })),
                React.createElement("div", { className: "".concat(baseClassName, "-fade-end") },
                    React.createElement(UitkScrim, { type: UitkScrimType.TRAILING, color: UitkScrimColorType.SECONDARY })))),
        priceLockup && (React.createElement(UitkLayoutGridItem, { colSpan: { small: 8, medium: 2, extra_large: 2 } },
            React.createElement(UitkLayoutGrid, { justifyItems: "end" }, secondaryContent === null || secondaryContent === void 0 ? void 0 :
                secondaryContent.map(function (element, index) {
                    return element && (React.createElement(UitkLayoutGridItem, { key: "uitk-progress-indicator-secondary-content-".concat(index) },
                        React.createElement("div", null, element)));
                }),
                React.createElement(UitkLayoutGridItem, null,
                    React.createElement("div", null,
                        React.createElement(UitkPriceLockup, { align: UitkPriceLockupAlign.RIGHT, lockupPrice: priceLockup.lockupPrice || undefined, priceSubtextStandard: priceLockup.priceSubtextStandard || undefined, a11yPrice: priceLockup.a11yPrice, strikeThroughPrice: priceLockup.strikeThroughPrice || undefined }))))))));
};
UitkProgressIndicator.displayName = 'UitkProgressIndicator';

export { UitkProgressIndicator };
